import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { Compass, Briefcase, ArrowRight, ShieldCheck, HandHeart, MapPin, Users } from "lucide-react";
import { VerticalHeader, VerticalFooter, VERTICAL_THEMES } from "./BrandChrome";
import "./asg.css";

const IMG_YATRA = "https://images.unsplash.com/photo-1626621341517-bbf3d9990a23?auto=format&fit=crop&w=1600&q=80"; // Kedarnath temple with Himalayan backdrop
const IMG_JOBS = "https://images.unsplash.com/photo-1521737604893-d14cc237f11d?auto=format&fit=crop&w=1600&q=80";  // Corporate meeting

export default function Umbrella() {
  return (
    <div className="asg-umbrella" data-testid="umbrella-page">
      <Helmet>
        <title>Arth Setuu Global — Sacred Journeys & Career Solutions | Patna, India</title>
        <meta name="description" content="Arth Setuu Global — pilgrim journeys across India and Nepal, plus professional HR consultancy connecting talent with the right opportunities. Bridging faith. Building careers." />
        <meta name="keywords" content="Arth Setuu Global, yatra, spiritual travel, HR consultancy, recruitment, jobs Patna, career opportunities, pilgrim tours, resume service" />
        <link rel="canonical" href="https://arthsetuuglobal.in/" />
      </Helmet>

      <VerticalHeader theme={VERTICAL_THEMES.umbrella} currentVertical="umbrella" />

      <section className="asg-hero" data-testid="umbrella-hero">
        <div className="asg-hero-inner">
          <span className="asg-hero-eyebrow">Arth Setuu Global · Est. Patna, India</span>
          <h1>Bridging faith. <em>Building careers.</em></h1>
          <p>
            An umbrella brand for two things India cares deeply about — sacred journeys that renew the spirit, and professional recruitment that shapes the career. Choose your path.
          </p>
        </div>
      </section>

      <section className="asg-duo" data-testid="umbrella-duo">
        <Link to="/yatra" className="asg-duo-card asg-duo-yatra" data-testid="vcard-yatra" style={{ backgroundImage: `linear-gradient(120deg, rgba(11,18,32,.55) 0%, rgba(180,83,9,.55) 100%), url(${IMG_YATRA})` }}>
          <div className="asg-duo-inner">
            <span className="asg-duo-num">01 — Vertical</span>
            <div className="asg-duo-icon"><Compass size={30} /></div>
            <h2>YATRA</h2>
            <p className="asg-duo-tag">Discover Sacred Journeys</p>
            <p className="asg-duo-desc">Explore spiritual, pilgrimage and heritage journeys across India and Nepal — curated with comfort, care and quiet devotion.</p>
            <ul className="asg-duo-list">
              <li>25+ curated yatras · Char Dham · Jyotirlinga · Rameswaram</li>
              <li>Reservation coaches, trusted operators, family-first care</li>
              <li>3,500+ pilgrims served since inception</li>
            </ul>
            <span className="asg-duo-cta">EXPLORE YATRA <ArrowRight size={16} /></span>
          </div>
        </Link>

        <Link to="/jobs" className="asg-duo-card asg-duo-jobs" data-testid="vcard-jobs" style={{ backgroundImage: `linear-gradient(120deg, rgba(11,18,32,.6) 0%, rgba(29,78,216,.55) 100%), url(${IMG_JOBS})` }}>
          <div className="asg-duo-inner">
            <span className="asg-duo-num">02 — Vertical</span>
            <div className="asg-duo-icon"><Briefcase size={30} /></div>
            <h2>JOBS</h2>
            <p className="asg-duo-tag">Building Careers. Connecting Talent.</p>
            <p className="asg-duo-desc">Professional recruitment and career solutions connecting the right talent with the right opportunities — 21 years of HR consultancy experience.</p>
            <ul className="asg-duo-list">
              <li>Recruitment, talent acquisition & candidate placement</li>
              <li>Career guidance & professional resume services (₹499)</li>
              <li>1,500+ candidates placed across industries</li>
            </ul>
            <div className="asg-duo-cta-row">
              <span className="asg-duo-cta">EXPLORE JOBS <ArrowRight size={16} /></span>
              <span className="asg-duo-cta-secondary">HIRE TALENT</span>
            </div>
          </div>
        </Link>
      </section>

      <section className="asg-umbrella-extras" data-testid="umbrella-trust">
        <h3>Rooted in Patna. Serving India.</h3>
        <p>Bandhu Market, Danapur — where our journey began. Whether you're seeking a sacred yatra or a professional recruitment partner, our team is here in person and on WhatsApp.</p>
        <div className="asg-callouts">
          <div className="asg-callout"><ShieldCheck size={16} color="#FCD34D" /><b style={{marginTop:8}}>Trust First</b>Transparent pricing, clear paperwork and human support at every step.</div>
          <div className="asg-callout"><HandHeart size={16} color="#93C5FD" /><b style={{marginTop:8}}>People-Powered</b>A team that listens — in Hindi, English and the language of care.</div>
          <div className="asg-callout"><Users size={16} color="#FDA4AF" /><b style={{marginTop:8}}>Experience</b>21+ years in HR · 3,500+ pilgrims · relationships that outlast projects.</div>
          <div className="asg-callout"><MapPin size={16} color="#6EE7B7" /><b style={{marginTop:8}}>Local + National</b>Patna office · pan-India delivery across yatras and careers.</div>
        </div>
      </section>

      <VerticalFooter theme={VERTICAL_THEMES.umbrella} />
    </div>
  );
}
